{
  "hsk2": {
    "1": 176,
    "2": 176,
    "3": 269,
    "4": 446,
    "5": 620,
    "6": 976
  },
  "hsk2026": {
    "1": 246,
    "2": 125,
    "3": 284,
    "4": 441,
    "5": 431,
    "6": 413,
    "7": 1148
  },
  "hsk3": {
    "1": 300,
    "2": 300,
    "3": 300,
    "4": 300,
    "5": 300,
    "6": 300,
    "7": 1200
  }
}
